module.exports = __webpack_public_path__ + "img/up-arrow.50d55855.svg";